import React, { useState } from 'react'
import clsx from 'clsx'
import { Input, Button } from '@ow/comps'
import { AddIcon } from '@ow/icons'
import Tree from './tree/tree'
import AddOrg from './components/group/operateGroup'

const groups = [
  { code: 'all', title: '全部用户', icon: null },
  // { code: 'unApproved', title: '待审批', icon: null },
  // { code: 'unGrouped', title: '未分组', icon: null },
  // { code: 'unActive', title: '未激活', icon: null },
  // { code: 'resigned', title: '已离职', icon: null },
  { code: 'disabled', title: '已禁用', icon: null },
]

const Sidebar = function ({ appId, updateSearchData, useOrg }) {
  const {
    orgs,
    currentOrg,
    currentGroup,
    orgOperate,
    customInfo,
    userFilter: { onSelectOrg, onSelectGroup },
  } = useOrg
  const [popupOpen, setOpen] = useState(false)

  // 点击组织
  // const onSelectOrg = (keys, info) => {
  //   console.log(keys)
  //   const { node } = info
  //   dispatch({
  //     type: 'set-org',
  //     payload: node,
  //   })
  //   dispatch({
  //     type: 'set-group',
  //     payload: null,
  //   })
  //   // 获取该组织的角色
  //   rolesByOrg(appId, { parentOrgId: key }).then((data = []) => {
  //     dispatch({
  //       type: 'set-orgroles',
  //       payload: data.map((item) => {
  //         return { value: item.slug, label: item.name, id: item.id }
  //       }),
  //     })
  //   })
  // }

  // 点击用户分组
  // const onSelectGroup = (group) => {
  //   const { code } = group
  //   dispatch({
  //     type: 'set-group',
  //     payload: code,
  //   })
  //   dispatch({
  //     type: 'set-org',
  //     payload: null,
  //   })
  // }

  return (
    <div className="flex flex-col w-full h-full p-5">
      <div className="w-full flex flex-col">
        <Input
          autoComplete="off"
          className="w-full px-4"
          style={{ color: '#3c4d62' }}
          placeholder="搜索用户"
          onChange={(e) => {
            updateSearchData(e.target.value)
          }}
        />

        <div
          className="w-full border-style border-t border-b pt-2 pb-2 mt-2"
          style={{ color: '#2d3748' }}
        >
          {groups.map((item) => {
            return (
              <Button
                className={clsx([
                  'w-full flex justify-start items-center mt-1',
                ])}
                type={item.code === currentGroup ? 'primary' : 'default'}
                key={item.code}
                onClick={() => {
                  onSelectGroup(item)
                }}
              >
                <span
                  style={{
                    color: item.code === currentGroup ? '#fff' : '#526484',
                    fontSize: '0.8125rem',
                  }}
                >
                  {item.title}
                </span>
              </Button>
            )
          })}
        </div>
      </div>
      <div className="mt-4 w-full flex flex-row justify-between items-center pl-3 pb-2 font-semibold h-4 relative top-0 left-0">
        <span>组织架构</span>
        {(!Object.keys(customInfo).length ||
          (customInfo && customInfo.isAddOrg === 'true')) && (
          <div
            className="cursor-pointer"
            onClick={() => {
              setOpen(true)
            }}
            title="添加一级组织"
          >
            <AddIcon width={16} height={16} fill="#6576ff" />
          </div>
        )}
      </div>
      <div className="flex-1 mt-2">
        <Tree
          datas={orgs}
          onSelect={onSelectOrg}
          selectedKeys={currentOrg && [currentOrg.key]}
        />
      </div>

      <AddOrg
        appId={appId}
        action="add"
        title="添加一级组织"
        orgOperate={orgOperate}
        oneLevel
        useOrg={useOrg}
        closeModal={() => {
          setOpen(false)
        }}
        open={popupOpen}
      />
    </div>
  )
}

export default Sidebar
